module.exports = __webpack_public_path__ + "img/Maria_gr.0bc5fac1.jpg";